export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
    instructions() {
      return this.$store.state.news.instructions;
    },
  },
  methods: {
    getInstruction(id) {
      this.$router.push(`/instruction/${id}`);
    },
  },
  created() {
    this.user.profile_id && this.$store.dispatch('news/GetInstructions', this.user.profile_id);
  },
};
